import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, HostListener } from '@angular/core';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {
  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger, static: true }) searchAutocomplete: MatAutocompleteTrigger;
  public searchText = '';
  public searchAutoSuggestions: string[] = [];
  public windowWidth: number;
  @ViewChildren('autoCompleteInput') elasticSearchBar: QueryList<ElementRef>;

  constructor(private commonService: TCCPCommonService) { }


  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.windowWidth = window.innerWidth;
  }

  ngOnInit() {
    this.windowWidth = window.innerWidth;
  }

  ngAfterViewInit() {
    this.elasticSearchBar.first.nativeElement.focus();
  }

  onSearchTextChange(searchText) {
    if (searchText !== '') {
      this.commonService.getSearchSuggestions(searchText).subscribe(response => {
        if (response && response.length > 0) {
          this.searchAutoSuggestions = response[0].options.map(x => x._source.contentTitle);
        }
      });
    } else {
      this.searchAutoSuggestions = [];
      this.commonService.searchResultEmitter.emit(this.searchText);
    }
  }

  onSearchTextEnter(searchText) {
    this.searchAutocomplete.closePanel();
    this.commonService.searchResultEmitter.emit(this.searchText);
  }

  getQuickLinks() {
    this.commonService.getQuickLinks().subscribe(response => {
      if (response) {
      }
    });
  }

  onCloseSearchPage() {
    this.commonService.hideBreadrumb.emit(false );
    window.history.back();
  }

}
